import { render, staticRenderFns } from "./ForgotPass.vue?vue&type=template&id=804f960c&scoped=true"
import script from "./ForgotPass.vue?vue&type=script&lang=js"
export * from "./ForgotPass.vue?vue&type=script&lang=js"
import style0 from "./ForgotPass.vue?vue&type=style&index=0&id=804f960c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "804f960c",
  null
  
)

export default component.exports